import type { EndUserStatus } from '../types/end-users.types';
import type { StatusVariant } from '@/shared/components/ui/status-badge';

export const statusVariantMap: Record<EndUserStatus, StatusVariant> = {
  active: 'active',
  pending: 'warning',
  blocked: 'error',
  inactive: 'inactive',
};

export const statusLabelMap: Record<EndUserStatus, string> = {
  active: 'Activo',
  pending: 'Pendiente',
  blocked: 'Bloqueado',
  inactive: 'Inactivo',
};

export const authProviderLabelMap: Record<string, string> = {
  Email: 'Email / Contraseña',
  Google: 'Google',
  Facebook: 'Facebook',
  Microsoft: 'Microsoft / Azure AD',
};
